var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-field-rich-text",class:{ 'is-border': _vm.isBorderStyle }},[(_vm.content)?[(_vm.isBorderStyle)?[_c('div',{staticClass:"rich-text-border-wrap"},[_c('RichTextPreview',{attrs:{"html":_vm.content}})],1)]:[_c('RichTextPreview',{attrs:{"html":_vm.content}})]]:[_c('span',{staticClass:"field-empty"},[_vm._v("-")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }